export const UrlQueryParameter = (search, key) => {
    const params = new URLSearchParams(search);
    const foo = params.get(key); 
    return foo;
} 